<template>
  <div class="legal-page">
    <iframe
      v-if="doc"
      :srcdoc="doc.html"
      :title="doc.title"
      class="legal-frame"
    ></iframe>
    <div v-else class="legal-missing">
      <h1>Policy not found</h1>
      <p>The document you're looking for doesn't exist.</p>
      <a href="/">Back to Off The Couch</a>
    </div>
  </div>
</template>

<script>
import privacyPolicy from './docs/privacy-policy';
import termsOfService from './docs/terms-of-service';
import playerPortalTerms from './docs/player-portal-terms';
import rateCard from './docs/rate-card';

const DOCS = {
  'privacy-policy': { title: 'Privacy Policy', html: privacyPolicy },
  'terms-of-service': { title: 'Terms of Service', html: termsOfService },
  'player-portal-terms': { title: 'Player Portal Terms of Use', html: playerPortalTerms },
  // Not a legal document, but it wants the same plain, tabulated treatment
  'rate-card': { title: 'Rate card', html: rateCard },
};

export default {
  name: 'LegalDocument',
  computed: {
    doc() {
      return DOCS[this.$route.params.doc] || null;
    },
  },
};
</script>

<style scoped>
.legal-page {
  position: fixed;
  inset: 0;
  background: #ffffff;
}
.legal-frame {
  width: 100%;
  height: 100%;
  border: 0;
  display: block;
}
.legal-missing {
  position: fixed;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  text-align: center;
  background: #1d1e3a;
  color: #fff;
  font-family: 'Poppins', sans-serif;
}
.legal-missing a { color: #e14eca; }
</style>
